import { useState } from "react";
import { useMainContext } from "../../Context";
import { dashboard } from "../../Utils/Apis";
import { useEffect } from "react";

export const useLayout = () => {
  const [data, setState] = useState({});
  const [loading, setLoading] = useState(true);
  const {
    get,
    state: {
      user: { user },
    },
  } = useMainContext();
  const getData = async () => {
    setLoading(true);
    const { data } = await get(dashboard);
    setState(data);
    setLoading(false);
  };
  useEffect(() => {
    getData();
  }, []);

  return { data, loading, user };
};
